import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { ApplicationContext } from "../utils/contextsProviders";

const CustomerAdminPrivateRoute = ({ children }) => {
  const { user } = useContext(ApplicationContext)
  return user ?  user?.role === "CustomerAdmin" || user?.role === "SuperAdmin" ? children : <Navigate to="/" /> : <h1>Loading......</h1>;
};

export default CustomerAdminPrivateRoute;